import React, { FC, useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import DataTable from 'components/shared/DataTable';
import { Column } from 'components/shared/DataTable/DataTable';
import Grid from 'components/UI/Grid';
import Loading from 'components/UI/Loading/Loading';
import { useStores } from 'stores/hooks/hooks';
import { Paper } from '@mui/material';
import { FilterMatchMode } from 'primereact/api';
import { DataTableRowClickEvent } from 'primereact/datatable';
import { BooleanBody } from './Components';

// export interface SystemSensorType {
//   id: number;
//   type: string;
//   family: string;
//   group: string;
//   name: string;
//   identifier: string;
//   physical: boolean;
//   active: boolean;
//   manufacturer: string;
//   convertedUnitMin: number;
//   convertedUnitMax: number;
//   expectedUnitMin: number;
//   expectedUnitMax: number;
//   temperature: string;
//   factor: number;
//   bias: number;
//   excitation: string;
//   measures: string;
//   requiredConfig: string | null;
//   pn: string;
//   description: string;
//   comments: string | null;
//   npi: string;
//   linear: boolean;
//   parentTypeId: string | null;
//   expectedUnits: string;
//   convertedUnits: string;
//   beanName: string;
//   iop: boolean;
//   tal: boolean;
//   classifier: string;
// }

const StyledGrid = styled(Grid)`
  display: flex;
  flex: unset;
  height: 100%;
  width: 100%;
  align-items: normal;
`;

const DataTableContainer = styled(Paper)`
  overflow: hidden;
  height: 100%;
  background-color: var(--surface-ground);
`;

const SensorsTable: FC = observer(() => {
  const { t } = useTranslation('staticData');
  const { resellersStore, systemsStore } = useStores();
  const {
    growerSystems,
    getGrowerSystems,
    getGrowerSystemSensors,
    globalFilter,
    selectedRowsSystems,
    setSelectedRowsSystems,
  } = resellersStore;

  const [filters, setFilters] = useState({
    global: { value: '', matchMode: FilterMatchMode.CONTAINS },
    id: { value: '', matchMode: FilterMatchMode.CONTAINS },
    type: { value: '', matchMode: FilterMatchMode.CONTAINS },
    group: { value: '', matchMode: FilterMatchMode.CONTAINS },
    family: { value: '', matchMode: FilterMatchMode.CONTAINS },
    parentTypeId: { value: '', matchMode: FilterMatchMode.CONTAINS },
    classifier: { value: '', matchMode: FilterMatchMode.CONTAINS },
    name: { value: '', matchMode: FilterMatchMode.CONTAINS },
    identifier: { value: '', matchMode: FilterMatchMode.CONTAINS },
    manufacturer: { value: '', matchMode: FilterMatchMode.CONTAINS },
    temperature: { value: '', matchMode: FilterMatchMode.CONTAINS },
    factor: { value: '', matchMode: FilterMatchMode.CONTAINS },
    bias: { value: '', matchMode: FilterMatchMode.CONTAINS },
    excitation: { value: '', matchMode: FilterMatchMode.CONTAINS },
    measures: { value: '', matchMode: FilterMatchMode.CONTAINS },
    physical: { value: '', matchMode: FilterMatchMode.CONTAINS },
    pn: { value: '', matchMode: FilterMatchMode.CONTAINS },
    description: { value: '', matchMode: FilterMatchMode.CONTAINS },
    comments: { value: '', matchMode: FilterMatchMode.CONTAINS },
    npi: { value: '', matchMode: FilterMatchMode.CONTAINS },
    active: { value: '', matchMode: FilterMatchMode.CONTAINS },
    linear: { value: '', matchMode: FilterMatchMode.CONTAINS },
    convertedUnitMin: { value: '', matchMode: FilterMatchMode.CONTAINS },
    convertedUnitMax: { value: '', matchMode: FilterMatchMode.CONTAINS },
    expectedUnitMin: { value: '', matchMode: FilterMatchMode.CONTAINS },
    expectedUnitMax: { value: '', matchMode: FilterMatchMode.CONTAINS },
    expectedUnits: { value: '', matchMode: FilterMatchMode.CONTAINS },
    convertedUnits: { value: '', matchMode: FilterMatchMode.CONTAINS },
    beanName: { value: '', matchMode: FilterMatchMode.CONTAINS },
    iop: { value: '', matchMode: FilterMatchMode.CONTAINS },
    tal: { value: '', matchMode: FilterMatchMode.CONTAINS },
  });

  const growerID = resellersStore.selectedGrowerId;

  const onRowClick = useCallback(({ data }: DataTableRowClickEvent) => {
    console.log(data);
  }, []);

  useEffect(() => {
    setFilters((prev) => {
      prev.global.value = globalFilter.trim();
      return { ...prev };
    });
  }, [globalFilter]);

  console.log(
    'asdasd',
    JSON.parse(JSON.stringify(systemsStore.sensorTypes.data)),
  );

  if (systemsStore.sensorTypes.loading) {
    return <Loading />;
  }

  return (
    <StyledGrid flex={1}>
      <DataTableContainer elevation={3}>
        <DataTable
          id="GrowerSystemsTable"
          showGridlines
          resizableColumns
          value={systemsStore.sensorTypes.data}
          selectionMode="single"
          scrollable
          scrollHeight="flex"
          dataKey="id"
          emptyMessage={t('empty_message')}
          stripedRows
          filters={filters}
          selection={selectedRowsSystems}
          onRowClick={onRowClick}
          filterDisplay="row"
          globalFilterFields={['name', 'type', 'identifier']}
          paginator
          rows={10}
        // pageSize={10}
        >
          <Column field="id" header={t('id')} sortable filter />
          <Column field="type" header={t('type')} sortable filter />
          <Column field="group" header={t('group')} sortable filter />
          <Column field="family" header={t('family')} sortable filter />
          <Column
            field="parentTypeId"
            header={t('parentTypeId')}
            sortable
            filter
          />
          <Column field="classifier" header={t('classifier')} sortable filter />
          <Column field="name" header={t('name')} sortable filter />
          <Column field="identifier" header={t('identifier')} sortable filter />
          <Column
            field="manufacturer"
            header={t('manufacturer')}
            sortable
            filter
          />
          <Column
            field="temperature"
            header={t('temperature')}
            sortable
            filter
          />
          <Column field="factor" header={t('factor')} sortable filter />
          <Column field="bias" header={t('bias')} sortable filter />
          <Column field="excitation" header={t('excitation')} sortable filter />
          <Column field="measures" header={t('measures')} sortable filter />
          <Column
            field="physical"
            header={t('physical')}
            sortable
            filter
            body={BooleanBody('physical')}
          />
          <Column field="pn" header={t('pn')} sortable filter />
          <Column
            field="description"
            header={t('description')}
            sortable
            filter
          />
          <Column field="comments" header={t('comments')} sortable filter />
          <Column field="npi" header={t('npi')} sortable filter />
          <Column
            field="active"
            header={t('active')}
            sortable
            filter
            body={BooleanBody('active')}
          />
          <Column
            field="linear"
            header={t('linear')}
            sortable
            filter
            body={BooleanBody('linear')}
          />
          <Column
            field="convertedUnitMin"
            header={t('convertedUnitMin')}
            sortable
            filter
          />
          <Column
            field="convertedUnitMax"
            header={t('convertedUnitMax')}
            sortable
            filter
          />
          <Column
            field="expectedUnitMin"
            header={t('expectedUnitMin')}
            sortable
            filter
          />
          <Column
            field="expectedUnitMax"
            header={t('expectedUnitMax')}
            sortable
            filter
          />
          <Column
            field="expectedUnits"
            header={t('expectedUnits')}
            sortable
            filter
          />
          <Column
            field="convertedUnits"
            header={t('convertedUnits')}
            sortable
            filter
          />
          <Column field="beanName" header={t('beanName')} sortable filter />
          <Column
            field="iop"
            header={t('iop')}
            sortable
            filter
            body={BooleanBody('iop')}
          />
          <Column
            field="tal"
            header={t('tal')}
            sortable
            filter
            body={BooleanBody('tal')}
          />
        </DataTable>
      </DataTableContainer>
    </StyledGrid>
  );
});

export default SensorsTable;
